import { STORAGE_KEYS } from '@/constants/storage'
import localStorage from '@/utils/localStorage'
import safeJSONParse from '@/utils/safeJSONParse'
import * as R from 'ramda'

/**
 * We store user preferences in localStorage. e.g, teams section, or lists section is expanded.
 * This mixin provides functions to get, set those flag values
 */
export default {
  methods: {
    setSidebarFlag(flag, value) {
      const flags = STORAGE_KEYS.sidebar.flags
      let sidebarPreferences = safeJSONParse(localStorage.getItem(STORAGE_KEYS.sidebar._key)) || {}
      sidebarPreferences = R.assocPath(
        [flags._key, flag._key],
        { value, expiresOn: flag.expiresOn },
        sidebarPreferences
      )
      localStorage.setItem(STORAGE_KEYS.sidebar._key, sidebarPreferences)
    },
    getSidebarFlag(flag) {
      const flags = STORAGE_KEYS.sidebar.flags
      const key = flag._key
      const flagMeta = flags[key]
      const defaultValue = flagMeta.defaultValue
      let sidebarPreferences = safeJSONParse(localStorage.getItem(STORAGE_KEYS.sidebar._key)) || {}
      return sidebarPreferences[flags._key]?.[key]?.value ?? defaultValue
    }
  }
}
